import type { Socket } from "socket.io-client";

export function registerSocketAuthRecovery(
  socket: Socket,
  refreshSession: () => Promise<unknown>,
  isActive: () => boolean,
) {
  let disposed = false;
  let refreshing = false;

  const recover = async () => {
    if (disposed || refreshing || !isActive()) return;

    refreshing = true;
    try {
      await refreshSession();
      if (disposed || !isActive()) return;

      // A new handshake reads the refreshed httpOnly cookie.
      socket.disconnect().connect();
    } catch {
      // A failed refresh must leave the socket disconnected.
    } finally {
      refreshing = false;
    }
  };

  socket.on("auth:expired", recover);
  return () => {
    disposed = true;
    socket.off("auth:expired", recover);
  };
}
